import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { motion, AnimatePresence } from 'framer-motion';

const CookieBanner = () => {
  const { t } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('vacature_cookie_consent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleChoice = (choice) => {
    localStorage.setItem('vacature_cookie_consent', choice);
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-6 left-6 right-6 z-[100] md:left-auto md:max-w-md md:right-12"
        >
          <div className="bg-white rounded-3xl p-8 shadow-[0_20px_50px_rgba(0,0,0,0.15)] border border-gray-100">
            <p className="text-sm text-gray-500 leading-relaxed font-medium mb-8">
              {t.cookieBanner.text}
              <Link to="/cookies" className="text-brand-orange font-bold hover:underline">
                {t.cookieBanner.linkText}
              </Link>.
            </p>
            <div className="flex gap-4">
              <button
                onClick={() => handleChoice('accepted')}
                className="flex-1 bg-brand-orange text-white py-4 rounded-xl text-xs font-black uppercase tracking-widest hover:bg-orange-600 transition-all shadow-lg hover:-translate-y-0.5"
              >
                {t.cookieBanner.accept}
              </button>
              <button
                onClick={() => handleChoice('declined')}
                className="flex-1 border-2 border-gray-100 text-gray-400 py-4 rounded-xl text-xs font-black uppercase tracking-widest hover:bg-gray-50 transition-all"
              >
                {t.cookieBanner.decline}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;